var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_385_7340)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1839 0C7.98216 0 1.33331 6.71805 1.33331 14.9198C1.33331 20.3376 4.23444 25.1079 8.56792 27.7222C8.56779 27.7339 8.56996 27.7412 8.5745 27.744C13.3099 30.6595 16.3253 31.9994 16.3253 31.9994C16.3253 31.9994 19.324 30.581 23.7954 27.744C23.8068 27.7368 23.8155 27.7251 23.8216 27.7091C28.1431 25.092 31.0346 20.3285 31.0346 14.9198C31.0346 6.71805 24.3857 0 16.1839 0Z",
    fill: "#2F5FE3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_385_7340",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 31,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1839 0C7.98216 0 1.33331 6.71805 1.33331 14.9198C1.33331 20.3376 4.23444 25.1079 8.56792 27.7222C8.56779 27.7339 8.56996 27.7412 8.5745 27.744C13.3099 30.6595 16.3253 31.9994 16.3253 31.9994C16.3253 31.9994 19.324 30.581 23.7954 27.744C23.8068 27.7368 23.8155 27.7251 23.8216 27.7091C28.1431 25.092 31.0346 20.3285 31.0346 14.9198C31.0346 6.71805 24.3857 0 16.1839 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_385_7340)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.644671,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82076 19.3235L16.2158 15.6138L16.2143 15.2304L22.597 19.2621L22.597 11.4928L16.1843 7.77234V7.78982L16.1842 7.77291L9.78589 11.5026L9.82076 19.3235Z",
    fill: "url(#paint0_linear_385_7340)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1837 15.2093C17.8971 14.2193 22.5886 11.5058 22.5983 11.5003L22.5976 19.2712L16.1837 22.965L16.1837 15.2093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.309408,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1841 15.2117L-3.04694 4.07904L-6.39861 10.0169L16.1841 22.9674L16.1841 15.2117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0924712,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1841 7.77612L-1.33593 -2.24786L-3.89221 3.5666C-3.89221 3.5666 5.00347 8.75201 9.77131 11.5069L16.1841 7.77612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1839 15.2158L9.78561 11.5075L9.82049 19.3284L16.1839 22.9716L16.1839 15.2158Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_385_7340",
    x: -44.8775,
    y: -46.2108,
    width: 122.123,
    height: 124.421,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 23.1054
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_385_7340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_385_7340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_385_7340",
    x1: 9.78589,
    y1: 19.3235,
    x2: 9.78589,
    y2: 7.77239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61e64c7ddeafe0491dbe1f6f1b0c09c5.svg";
export { ForwardRef as ReactComponent };